/* eslint-disable */
import * as Types from '../../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  docId: Types.Scalars['ID']['input'];
  parentItemId: Types.Scalars['ID']['input'];
}>;


export type QuoteTemplateUpdateFromItemMenuItem_ParentItemQuery = { item: { __typename: 'Item', id: string, originVersionNumber?: number | null, templateOriginQuoteId?: string | null } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type QuoteTemplateUpdateFromItemMenuItem_TemplateQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type QuoteTemplateUpdateFromItemMenuItem_TemplateQuery = { quoteTemplateLatestAvailableVersion: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateLatestAvailableVersionResult', quoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, title: string, owningSystemOrganisationId: string } | null } };


export const QuoteTemplateUpdateFromItemMenuItem_ParentItemDocument = gql`
    query QuoteTemplateUpdateFromItemMenuItem_ParentItem($projectId: ID, $docId: ID!, $parentItemId: ID!) {
  item(projectId: $projectId, docId: $docId, itemId: $parentItemId) {
    ... on Item {
      id
      originVersionNumber
      templateOriginQuoteId
    }
  }
}
    `;

/**
 * __useQuoteTemplateUpdateFromItemMenuItem_ParentItemQuery__
 *
 * To run a query within a React component, call `useQuoteTemplateUpdateFromItemMenuItem_ParentItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteTemplateUpdateFromItemMenuItem_ParentItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteTemplateUpdateFromItemMenuItem_ParentItemQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      docId: // value for 'docId'
 *      parentItemId: // value for 'parentItemId'
 *   },
 * });
 */
export function useQuoteTemplateUpdateFromItemMenuItem_ParentItemQuery(baseOptions: Apollo.QueryHookOptions<QuoteTemplateUpdateFromItemMenuItem_ParentItemQuery, QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryVariables> & ({ variables: QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteTemplateUpdateFromItemMenuItem_ParentItemQuery, QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryVariables>(QuoteTemplateUpdateFromItemMenuItem_ParentItemDocument, options);
      }
export function useQuoteTemplateUpdateFromItemMenuItem_ParentItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteTemplateUpdateFromItemMenuItem_ParentItemQuery, QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteTemplateUpdateFromItemMenuItem_ParentItemQuery, QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryVariables>(QuoteTemplateUpdateFromItemMenuItem_ParentItemDocument, options);
        }
export function useQuoteTemplateUpdateFromItemMenuItem_ParentItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuoteTemplateUpdateFromItemMenuItem_ParentItemQuery, QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuoteTemplateUpdateFromItemMenuItem_ParentItemQuery, QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryVariables>(QuoteTemplateUpdateFromItemMenuItem_ParentItemDocument, options);
        }
export type QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryHookResult = ReturnType<typeof useQuoteTemplateUpdateFromItemMenuItem_ParentItemQuery>;
export type QuoteTemplateUpdateFromItemMenuItem_ParentItemLazyQueryHookResult = ReturnType<typeof useQuoteTemplateUpdateFromItemMenuItem_ParentItemLazyQuery>;
export type QuoteTemplateUpdateFromItemMenuItem_ParentItemSuspenseQueryHookResult = ReturnType<typeof useQuoteTemplateUpdateFromItemMenuItem_ParentItemSuspenseQuery>;
export type QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryResult = Apollo.QueryResult<QuoteTemplateUpdateFromItemMenuItem_ParentItemQuery, QuoteTemplateUpdateFromItemMenuItem_ParentItemQueryVariables>;
export const QuoteTemplateUpdateFromItemMenuItem_TemplateDocument = gql`
    query QuoteTemplateUpdateFromItemMenuItem_Template($id: ID!) {
  quoteTemplateLatestAvailableVersion(id: $id) {
    ... on QuoteTemplateLatestAvailableVersionResult {
      quoteTemplate {
        id
        resolvedAsReadModelVersionNumber
        title
        owningSystemOrganisationId
      }
    }
  }
}
    `;

/**
 * __useQuoteTemplateUpdateFromItemMenuItem_TemplateQuery__
 *
 * To run a query within a React component, call `useQuoteTemplateUpdateFromItemMenuItem_TemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteTemplateUpdateFromItemMenuItem_TemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteTemplateUpdateFromItemMenuItem_TemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteTemplateUpdateFromItemMenuItem_TemplateQuery(baseOptions: Apollo.QueryHookOptions<QuoteTemplateUpdateFromItemMenuItem_TemplateQuery, QuoteTemplateUpdateFromItemMenuItem_TemplateQueryVariables> & ({ variables: QuoteTemplateUpdateFromItemMenuItem_TemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteTemplateUpdateFromItemMenuItem_TemplateQuery, QuoteTemplateUpdateFromItemMenuItem_TemplateQueryVariables>(QuoteTemplateUpdateFromItemMenuItem_TemplateDocument, options);
      }
export function useQuoteTemplateUpdateFromItemMenuItem_TemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteTemplateUpdateFromItemMenuItem_TemplateQuery, QuoteTemplateUpdateFromItemMenuItem_TemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteTemplateUpdateFromItemMenuItem_TemplateQuery, QuoteTemplateUpdateFromItemMenuItem_TemplateQueryVariables>(QuoteTemplateUpdateFromItemMenuItem_TemplateDocument, options);
        }
export function useQuoteTemplateUpdateFromItemMenuItem_TemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuoteTemplateUpdateFromItemMenuItem_TemplateQuery, QuoteTemplateUpdateFromItemMenuItem_TemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuoteTemplateUpdateFromItemMenuItem_TemplateQuery, QuoteTemplateUpdateFromItemMenuItem_TemplateQueryVariables>(QuoteTemplateUpdateFromItemMenuItem_TemplateDocument, options);
        }
export type QuoteTemplateUpdateFromItemMenuItem_TemplateQueryHookResult = ReturnType<typeof useQuoteTemplateUpdateFromItemMenuItem_TemplateQuery>;
export type QuoteTemplateUpdateFromItemMenuItem_TemplateLazyQueryHookResult = ReturnType<typeof useQuoteTemplateUpdateFromItemMenuItem_TemplateLazyQuery>;
export type QuoteTemplateUpdateFromItemMenuItem_TemplateSuspenseQueryHookResult = ReturnType<typeof useQuoteTemplateUpdateFromItemMenuItem_TemplateSuspenseQuery>;
export type QuoteTemplateUpdateFromItemMenuItem_TemplateQueryResult = Apollo.QueryResult<QuoteTemplateUpdateFromItemMenuItem_TemplateQuery, QuoteTemplateUpdateFromItemMenuItem_TemplateQueryVariables>;